import { Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };

import { MessageRow } from './MessageRow.tsx';

const textStyle = style({
	font: 'body',
	color: 'gray-600',
	fontSize: 'body-sm',
	fontStyle: 'italic',
});

export const ToolCommentMessage = ({ content }: { content: string }) => {
	return (
		<MessageRow>
			<Text styles={textStyle}>{content}</Text>
		</MessageRow>
	);
};
